import { Dialog, Pane, SelectField, TextInput, FormField, Textarea } from 'evergreen-ui';
import { normalizeTime } from '../../utils/timeUtils';

export default function ReperibilitaModal({
  isOpen, onClose, onSave,
  repInputs, setRepInputs,
  collaboratorsList,
}) {
  const set = (field, value) => setRepInputs(prev => ({ ...prev, [field]: value }));

  const handleCollaboratoreChange = (e) => {
    const name = e.target.value;
    const collab = collaboratorsList.find(c => `${c.nome} ${c.cognome}`.trim() === name);
    setRepInputs(prev => ({ ...prev, operator_name: name, operator_id: collab?.id ?? null }));
  };

  return (
    <Dialog
      isShown={isOpen}
      title={repInputs.id ? 'Modifica reperibilità' : 'Inserisci reperibilità'}
      onCloseComplete={onClose}
      confirmLabel={repInputs.id ? 'Aggiorna' : 'Salva'}
      onConfirm={onSave}
    >
      <Pane display="flex" flexDirection="column" gap={12} paddingBottom={8}>
        <SelectField
          label="Collaboratore"
          value={repInputs.operator_name}
          onChange={handleCollaboratoreChange}
          marginBottom={0}
        >
          <option value="">Seleziona...</option>
          {collaboratorsList.map(c => {
            const name = `${c.nome} ${c.cognome}`.trim();
            return <option key={c.id} value={name}>{name}</option>;
          })}
        </SelectField>

        <Pane display="flex" gap={12}>
          <FormField label="Ora inizio" flex={1}>
            <TextInput
              width="100%"
              value={repInputs.start_time}
              placeholder="08:00"
              onChange={e => set('start_time', e.target.value)}
              onBlur={e => set('start_time', normalizeTime(e.target.value))}
            />
          </FormField>
          <FormField label="Ora fine" flex={1}>
            <TextInput
              width="100%"
              value={repInputs.end_time}
              placeholder="16:00"
              onChange={e => set('end_time', e.target.value)}
              onBlur={e => set('end_time', normalizeTime(e.target.value))}
            />
          </FormField>
        </Pane>

        <SelectField
          label="Periodo"
          value={repInputs.period}
          onChange={e => set('period', e.target.value)}
          marginBottom={0}
        >
          <option value="giorno">☀ Giorno</option>
          <option value="notte">☾ Notte</option>
        </SelectField>

        <FormField label="Note (opzionale)">
          <Textarea
            value={repInputs.notes}
            onChange={e => set('notes', e.target.value)}
            placeholder="Note..."
            rows={2}
          />
        </FormField>
      </Pane>
    </Dialog>
  );
}
